module.exports = __webpack_public_path__ + "bbf212c6c737afd6c0deb1d96604d3d1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-25.png
// module id = 2119
// module chunks = 0